module.exports = __webpack_public_path__ + "static/media/Air-pollution-medium.d96d1141.svg";